module.exports = __webpack_public_path__ + "static/img/004-ban-3.8df77af9.jpg";